/* eslint-disable */
// These values are overridden through clientBuild.
// The values are taken from 00_40_ template
export const dynamicValues = {
  buildVersion: 'a6e20b955ba8a9a149c2782d0924284427ce1913',
};
/* eslint-enable */
